import { PropsWithChildren, createContext, useEffect, useState } from "react";

export type SidebarContextType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SIDEBAR_OPEN_KEY = "sidebar-open";

const SidebarContext = createContext({} as SidebarContextType);

export const SidebarProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_OPEN_KEY);
    return stored === null ? true : stored === "true";
  });

  useEffect(() => {
    localStorage.setItem(SIDEBAR_OPEN_KEY, String(isOpen));
  }, [isOpen]);

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        setIsOpen
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContext;
